import axios from 'axios'
import Vue from 'vue'
import { ToastPlugin } from 'bootstrap-vue'
Vue.use(ToastPlugin)

const service = axios.create({
  // baseURL: 'http://franke.lemondata.top',
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 720000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['Lemon-AppId'] = 'lemondata_franke'
    config.headers['Lemon-AppKey'] = 'lemon@lemondata.top'

    return config
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(

  response => {
    const res = response.data
    return res
  },
  error => {
    if (error.request.status === 500) {
      console.log(error.request.responseText)
    } else {
      console.log(error.message)
    }

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js